'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M128 768h768v192h-768v-192z' }),
        React.createElement('path', { d: 'M384 384v320h256v-320h224l-352-352-352 352z' })
    ));
};